export default "__VITE_ASSET__ab191b2b__"